type PhoneMockupProps = {
  label: string;
  imageSrc?: string | null;
  imageAlt?: string;
};

export function PhoneMockup({ label, imageSrc, imageAlt }: PhoneMockupProps) {
  return (
    <div className="phone" aria-hidden={imageSrc ? undefined : true}>
      <div className="phone-notch">
        <div className="phone-notch-pill" />
      </div>
      <div className="phone-screen">
        {imageSrc ? (
          <img
            className="phone-screenshot"
            src={imageSrc}
            alt={imageAlt ?? label}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="phone-placeholder">{label}</div>
        )}
      </div>
    </div>
  );
}
